<button class="main-btn" (click)="goToApp()">Crea il suo menù</button>
@if(popupIsOpen) {
    <div class="popup-backdrop">
        <div class="popup-box">
            <button class="close-button" (click)="close()">X</button>
            <ng-container>
                <app-logo></app-logo>
                <h2>{{serviceStatusData?.title}}</h2>
                <div class="container">
                    <p>{{serviceStatusData?.description}}</p>
                </div>
                <button class="main-btn nutrizionista-btn" (click)="close()">
                    Ok ho capito
                </button> 
            </ng-container>
        </div>
    </div>
}